import { render, staticRenderFns } from "./GuiasTabs.vue?vue&type=template&id=3c628a4a"
import script from "./GuiasTabs.vue?vue&type=script&lang=js"
export * from "./GuiasTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports